import withOrgId from './withOrgId';

export default withOrgId;
